import PropTypes from "prop-types";
import { Input } from "top-component-library";
import { FormRow } from "../styles";

const OrderRateLimitNameStep = ({ name, onChange }) => (
  <div>
    <h4>Name:</h4>
    <FormRow>
      <label htmlFor="throttle-name">Internal name for this limit</label>
      <Input id="throttle-name" maxLength={50} value={name} onChange={(event) => onChange(event.target.value)} />
    </FormRow>
  </div>
);

OrderRateLimitNameStep.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default OrderRateLimitNameStep;
